// TrezorAffiliateCTA — TopWallet affiliate CTA block.
// variant="full"    → 3 productos (Model One · Safe 3 · Model T)
// variant="compact" → solo Safe 3
// All links carry: target=_blank, rel="noopener noreferrer sponsored".
import React from "react";
import { i18nTrezor, pickLang } from "../../i18n/trezor-affiliate";

const TREZOR_BASE = "https://affiliate.trezor.io/signup/159881";

const PRODUCTOS = [
  {
    id: "trezor-model-one",
    nombre: "Trezor Model One",
    precio: "€49",
    badgeKey: "mejorPrecio",
    color: "#00e676",
    icono: "🟢",
    specs: {
      es: "USB · Bitcoin · Ethereum · +1.000 activos · Precio imbatible",
      en: "USB · Bitcoin · Ethereum · +1,000 assets · Unbeatable price",
      sk: "USB · Bitcoin · Ethereum · +1 000 aktív · Neprekonateľná cena", de: "USB · Bitcoin · Ethereum · +1.000 Assets · Unschlagbarer Preis", "zh-CN": "USB · Bitcoin · Ethereum · +1.000 资产 · 无与伦比的价格",
    },
  },
  {
    id: "trezor-safe-3",
    nombre: "Trezor Safe 3",
    precio: "€79",
    badgeKey: "masVendida",
    color: "#f5a623",
    icono: "⭐",
    specs: {
      es: "Secure Element · +8.000 activos · USB-C · El más recomendado",
      en: "Secure Element · +8,000 assets · USB-C · Most recommended",
      sk: "Secure Element · +8 000 aktív · USB-C · Najodporúčanejší", de: "Secure Element · +8.000 Assets · USB-C · Am meisten empfohlen", "zh-CN": "安全芯片 · +8.000 种资产 · USB-C · 最受推荐",
    },
  },
  {
    id: "trezor-model-t",
    nombre: "Trezor Model T",
    precio: "€169",
    badgeKey: "premium",
    color: "#9b59ff",
    icono: "💎",
    specs: {
      es: "Pantalla táctil · +8.000 activos · Shamir Backup · Avanzado",
      en: "Touchscreen · +8,000 assets · Shamir Backup · Advanced",
      sk: "Dotyková obrazovka · +8 000 aktív · Shamir Backup · Pokročilý", de: "Touchscreen · +8.000 Assets · Shamir Backup · Fortgeschritten", "zh-CN": "触摸屏 · +8,000 种资产 · Shamir 备份 · 高级",
    },
  },
];

const TrezorAffiliateCTA = ({ lang = "es", tracker, variant = "full" }) => {
  const L = ["es", "en", "sk", "de", "zh-CN"].includes(lang) ? lang : "en";
  const t = (key) => pickLang(i18nTrezor[key], L);
  const base = `${TREZOR_BASE}?sub1=${tracker}`;

  // COMPACT — solo Safe 3
  if (variant === "compact") {
    const prod = PRODUCTOS[1];
    return (
      <div
        data-testid={`trezor-cta-compact-${tracker}`}
        style={{
          background: "rgba(0,230,118,.04)",
          border: "1px solid rgba(0,230,118,.15)",
          borderRadius: 10,
          padding: "14px 18px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 12,
          flexWrap: "wrap",
          marginTop: 16,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <span style={{ fontSize: 20 }}>🟩</span>
          <div>
            <div style={{ fontSize: 13, fontWeight: 600, color: "#f0f4ff" }}>
              {prod.nombre} — {prod.precio}
            </div>
            <div style={{ fontSize: 11, color: "rgba(255,255,255,.4)", marginTop: 2 }}>
              {pickLang(prod.specs, L)}
            </div>
          </div>
        </div>
        <a
          href={base}
          target="_blank"
          rel="noopener noreferrer sponsored"
          data-testid={`trezor-cta-compact-link-${tracker}`}
          style={{
            background: "linear-gradient(135deg,#00e676,#00c853)",
            color: "#07080f",
            fontWeight: 700,
            fontSize: 12,
            letterSpacing: ".08em",
            padding: "8px 16px",
            borderRadius: 6,
            textDecoration: "none",
            whiteSpace: "nowrap",
            flexShrink: 0,
          }}
        >
          {t("comprarEn")}
        </a>
      </div>
    );
  }

  // FULL — 3 productos
  return (
    <div
      data-testid={`trezor-cta-full-${tracker}`}
      style={{
        marginTop: 40,
        background:
          "linear-gradient(135deg,rgba(0,230,118,.04),rgba(0,200,83,.02))",
        border: "1px solid rgba(0,230,118,.18)",
        borderRadius: 14,
        overflow: "hidden",
      }}
    >
      {/* Header */}
      <div
        style={{
          padding: "18px 22px 14px",
          borderBottom: "1px solid rgba(255,255,255,.06)",
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 8,
        }}
      >
        <div>
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 5,
              background: "rgba(0,230,118,.12)",
              border: "1px solid rgba(0,230,118,.3)",
              color: "#00e676",
              fontSize: 9,
              letterSpacing: ".2em",
              padding: "3px 10px",
              borderRadius: 100,
              marginBottom: 6,
            }}
          >
            🟩 {t("ctaBadge")}
          </div>
          <div style={{ fontSize: 17, fontWeight: 700, color: "#f0f4ff" }}>
            {t("ctaTitulo")}
          </div>
          <div
            style={{
              fontSize: 12,
              color: "rgba(255,255,255,.5)",
              marginTop: 4,
              maxWidth: 480,
            }}
          >
            {t("ctaSubtitulo")}
          </div>
        </div>
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 5,
            background: "rgba(0,230,118,.08)",
            border: "1px solid rgba(0,230,118,.2)",
            color: "rgba(0,230,118,.7)",
            fontSize: 9,
            letterSpacing: ".1em",
            padding: "4px 10px",
            borderRadius: 100,
            whiteSpace: "nowrap",
          }}
        >
          ✓ {t("openSource")}
        </div>
      </div>

      {/* Productos */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill,minmax(200px,1fr))",
          gap: 1,
          background: "rgba(255,255,255,.04)",
        }}
      >
        {PRODUCTOS.map((prod, idx) => (
          <div
            key={prod.id}
            style={{
              background: "#0a0b16",
              padding: "16px",
              display: "flex",
              flexDirection: "column",
              gap: 8,
            }}
          >
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 5,
                background: prod.color + "18",
                border: `1px solid ${prod.color}44`,
                color: prod.color,
                fontSize: 9,
                letterSpacing: ".15em",
                padding: "2px 8px",
                borderRadius: 100,
                width: "fit-content",
              }}
            >
              {prod.icono} {t(prod.badgeKey).toUpperCase()}
            </div>

            <div>
              <div style={{ fontSize: 14, fontWeight: 600, color: "#f0f4ff" }}>
                {prod.nombre}
              </div>
              <div
                style={{
                  fontSize: 22,
                  fontWeight: 900,
                  color: prod.color,
                  marginTop: 2,
                }}
              >
                {prod.precio}
              </div>
            </div>

            <div
              style={{
                fontSize: 11,
                color: "rgba(255,255,255,.4)",
                lineHeight: 1.5,
              }}
            >
              {pickLang(prod.specs, L)}
            </div>

            <a
              href={base}
              target="_blank"
              rel="noopener noreferrer sponsored"
              data-testid={`trezor-cta-full-link-${prod.id}-${tracker}`}
              style={{
                marginTop: "auto",
                display: "block",
                textAlign: "center",
                background:
                  idx === 1
                    ? "linear-gradient(135deg,#00e676,#00c853)"
                    : "none",
                border: idx === 1 ? "none" : `1px solid ${prod.color}55`,
                color: idx === 1 ? "#07080f" : prod.color,
                fontWeight: 700,
                fontSize: 12,
                letterSpacing: ".08em",
                padding: "9px 14px",
                borderRadius: 7,
                textDecoration: "none",
                transition: "all .2s",
              }}
            >
              {t("comprarEn")}
            </a>
          </div>
        ))}
      </div>

      {/* Footer */}
      <div
        style={{
          padding: "12px 22px",
          borderTop: "1px solid rgba(255,255,255,.06)",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 8,
        }}
      >
        <p
          style={{
            fontSize: 10,
            color: "rgba(255,255,255,.35)",
            margin: 0,
            maxWidth: 480,
          }}
        >
          * {t("aviso")}
        </p>
        <a
          href={base}
          target="_blank"
          rel="noopener noreferrer sponsored"
          data-testid={`trezor-cta-full-vertodos-${tracker}`}
          style={{
            fontSize: 11,
            color: "rgba(0,230,118,.7)",
            textDecoration: "none",
            letterSpacing: ".05em",
            whiteSpace: "nowrap",
          }}
        >
          {t("verTodos")}
        </a>
      </div>
    </div>
  );
};

export default TrezorAffiliateCTA;
